// The production image serves /config.js, written at container start from the
// pod's env (docker/spa-config.php), so one build runs in any environment. Local
// dev ships an empty public/config.js and falls back to the VUE_APP_* values in .env.
const runtime = window.__TRUNIMAL_CONFIG__ || {};

export const apiUrl = runtime.apiUrl || process.env.VUE_APP_API_URL;
export const stripeKey = runtime.stripeKey || process.env.VUE_APP_STRIPE_KEY;
export const clientUrl = runtime.clientUrl || process.env.VUE_APP_CLIENT_URL;
export const websiteUrl = runtime.websiteUrl || process.env.VUE_APP_WEBSITE_URL || "https://www.trunimal.com";
